// src/routes/BlogPostPage.js
import React from "react";
import { useParams } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import DetailLayout from "../components/DetailLayout";
import PostEngagement from "../components/PostEngagement";
import { useSite } from "../context/SiteContext";
import { useData } from "../hooks/useData";
import { getPostBySlug } from "../firebase/dataService";

const formatDate = (ts) => {
  if (!ts) return "";
  try {
    const d = typeof ts.toDate === "function" ? ts.toDate() : new Date(ts);
    return d.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
  } catch { return ""; }
};

const BlogPostPage = () => {
  const { slug } = useParams();
  const { data: post, loading, error } = useData(() => getPostBySlug(slug), [slug]);
  const { profile } = useSite();

  return (
    <div>
      <Navbar />
      {loading ? (
        <div className="container" style={{ padding: "9rem 0", textAlign: "center" }}>
          <FaSpinner className="spin" size={22} />
        </div>
      ) : error || !post ? (
        <div className="container" style={{ padding: "9rem 0", textAlign: "center" }}>
          <p style={{ color: "var(--text-2)" }}>Post not found.</p>
        </div>
      ) : (
        <DetailLayout
          backTo="/blog"
          backLabel="All posts"
          coverImage={post.coverImage}
          eyebrow={post.category || "Blog"}
          title={post.title}
          meta={[
            formatDate(post.publishedAt || post.createdAt),
            ...(Array.isArray(post.tags) ? post.tags : []),
          ].filter(Boolean)}
        >
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{post.body || ""}</ReactMarkdown>
          {post.id && <PostEngagement post={post} authorName={(profile?.name || "").split(" ")[0] || "Author"} />}
        </DetailLayout>
      )}
      <Footer />
    </div>
  );
};

export default BlogPostPage;
